import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { NavLink } from "react-router-dom";

import classNames from "../Helpers/Classnames";

export default function MobileNavigation({navigation, open, setOpen, onJumpToSection}) {
  const cancelButtonRef = useRef(null);
  
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >

        <div className="fixed z-10 inset-0 overflow-y-hidden lg:hidden w-full">
          <div className="flex mt-[12.5vh] items-start justify-center min-h-full text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-100"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Panel className="relative bg-coastal-700 p-3 pb-6 text-left overflow-hidden transform transition-all w-full">

                {navigation.map((item) => {
                  if (item.type === "anchor") {
                    return (
                      <a
                        key={item.name}
                        href={item.href}
                        onClick={(event) => {
                          onJumpToSection(event, item.sectionId);
                          setOpen(false);
                        }}
                        className="flex my-auto mx-1 px-3 py-1.5 text-lg rounded-md text-white hover:bg-coastal-100 hover:text-coastal-900"
                      >
                        {item.name}
                      </a>
                    );
                  }

                  return (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      end={item.end ? item.end : false}
                      onClick={() => setOpen(false)}
                    >
                      {({ isActive }) => (
                        <span
                          className={classNames(
                            isActive
                              ? "text-coastal-200"
                              : "text-white hover:bg-coastal-100 hover:text-coastal-900",
                            "flex my-auto mx-1 px-3 py-1.5 text-lg rounded-md"
                          )}
                        >
                          {item.name}
                        </span>
                      )}
                    </NavLink>
                  );
                })}

                <div className="mt-4 border-t border-coastal-500 pt-4 px-2 text-sm text-coastal-100">
                  <a href="tel:07769943317" onClick={() => setOpen(false)} className="block py-1 hover:text-white">Mobile: 07769943317</a>
                  <a
                    href="mailto:calmcoasthypnotherapy@hotmail.com"
                    onClick={() => setOpen(false)}
                    className="block py-1 break-all hover:text-white"
                  >
                    calmcoasthypnotherapy@hotmail.com
                  </a>
                  <a
                    href="/#contact"
                    onClick={(event) => {
                      onJumpToSection(event, "contact");
                      setOpen(false);
                    }}
                    className="mt-3 inline-flex rounded-full bg-coastal-100 px-4 py-2 font-semibold text-coastal-900"
                  >
                    Get In Touch
                  </a>
                </div>

              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
